module.exports = __webpack_public_path__ + "static/media/grosjojo.d8a40e08.gif";